import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';
import { TrackerService } from '../../services/tracker.service';

@Component({
  selector: 'tracker-delete',
  template: require('./tracker.delete.modal.component.html')
})
export class TrackerDeleteComponent extends ModalComponent {
  @Input() tracker: any;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  isLoading = false;

  constructor(private trackerService: TrackerService) {
    super();
  }

  deleteTracker() {
    this.isLoading = true;

    this.trackerService.delete(this.tracker)
      .then(() => {
        this.onDelete.emit(this.tracker);
        this.closeModal();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
